// extracted by mini-css-extract-plugin
module.exports = {"titleContainerPeople":"styles_titleContainerPeople__aA-i5","titlePeopleLabel":"styles_titlePeopleLabel__nzY-l","titleInputPeople":"styles_titleInputPeople__7PsBt"};